import "./styles.css";

export default function ArticleTypeDefiner({
	typeCode,
	qtdTopics,
	topics,
	titleArticle,
	descArticle,
	articleImageURL,
	videoURL,

	setTopics,
	setQtdTopics,
	setArticleTitle,
	setArticleDesc,
	setArticleImageURL,
	setVideoURL,
}) {
	if (typeCode === null) {
		return <h3>Nenhum tipo de artigo selecionado.</h3>;
	}

	async function createArticleImageURL(file) {
		const formData = new FormData();
		formData.append("file", file);
		formData.append("upload_preset", "free_upload");

		try {
			const res = await fetch(
				"https://api.cloudinary.com/v1_1/dxk06cdb4/image/upload",
				{
					method: "POST",
					body: formData,
				}
			);

			const data = await res.json();
			setArticleImageURL(data.secure_url);
			console.log("URL da imagem:", data.secure_url);
		} catch (error) {
			console.error("Erro ao enviar imagem:", error);
		}
	}

	function getEmbedUrl(url) {
		if (/^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\//.test(url)) {
			const videoIdMatch = url.match(
				/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]{11})/
			);
			if (videoIdMatch && videoIdMatch[1]) {
				return `https://www.youtube.com/embed/${videoIdMatch[1]}`;
			}
		}
		return url; // se não for do YouTube, retorna como está
	}

	const handleChangeQtd = (e) => {
		const value = parseInt(e.target.value);
		if (!isNaN(value)) {
			setQtdTopics(value);
			setTopics(Array(value).fill(""));
		} else {
			setQtdTopics(null);
		}
	};

	const loadTopics = () => {
		return Array.from({ length: qtdTopics }).map((_, i) => (
			<div key={i}>
				<input
					type="text"
					placeholder={`${i + 1} Item da lista`}
					value={topics[i] || ""}
					onChange={(e) => {
						const updatedTopics = [...topics];
						updatedTopics[i] = e.target.value;
						setTopics(updatedTopics);
					}}
				/>
			</div>
		));
	};

	switch (typeCode) {
		case 1:
			return (
				<div className="articleDefiner-wrapper">
					<div className="input-wrapper">
						<label htmlFor="topicInput">Titulo do artigo</label>
						<input
							value={titleArticle}
							id="topicInput"
							type="text"
							onChange={(e) => {
								setArticleTitle(e.target.value);
							}}
						/>
					</div>
					<div className="input-wrapper">
						<label htmlFor="descriptionTopics">Descrição do artigo</label>
						<textarea
							name="descriptionTopics"
							id="descriptionTopics"
							value={descArticle}
							onChange={(e) => {
								setArticleDesc(e.target.value);
							}}></textarea>
					</div>
					<div className="input-wrapper">
						<label htmlFor="qtdTopics">quatidade de topicos</label>
						<input
							type="number"
							id="qtdTopics"
							value={qtdTopics}
							onChange={handleChangeQtd}
							min={0}
						/>
					</div>
					<div className="topics-wrapper">{loadTopics()}</div>
				</div>
			);

		case 2:
			return (
				<div className="articleDefiner-wrapper">
					<div className="input-wrapper">
						<label htmlFor="topicInput">Titulo do artigo</label>
						<input
							id="topicInput"
							type="text"
							onChange={(e) => setArticleTitle(e.target.value)}
							value={titleArticle}
						/>
					</div>
					<div className="input-wrapper">
						<label htmlFor="descriptionTopics">Descrição do artigo</label>
						<textarea
							name="descriptionTopics"
							id="descriptionTopics"
							onChange={(e) => setArticleDesc(e.target.value)}
							value={descArticle}></textarea>
					</div>
					<div className="input-wrapper">
						<label htmlFor="qtdTopics">quatidade de topicos</label>
						<input
							type="number"
							id="qtdTopics"
							onChange={handleChangeQtd}
							value={qtdTopics}
							min={0}
						/>
					</div>
					<div className="topics-wrapper">{loadTopics()}</div>
				</div>
			);

		case 3:
			return (
				<div className="articleDefiner-wrapper">
					<div className="input-wrapper">
						<label htmlFor="titleArticle">Titulo do artigo</label>
						<input
							type="text"
							id="titleArticle"
							onChange={(e) => setArticleTitle(e.target.value)}
							value={titleArticle}
						/>
					</div>
					<div className="input-wrapper">
						<label htmlFor="descriptionArticle">Descrição do artigo</label>
						<textarea
							id="descriptionArticle"
							onChange={(e) => setArticleDesc(e.target.value)}
							value={descArticle}></textarea>
					</div>
					<div className="input-wrapper">
						<label htmlFor="articleImage">Imagem do artigo</label>
						<input
							type="file"
							accept="image/jpeg, image/png, image/jpg"
							id="articleImage"
							alt="imagem"
							onChange={(e) => {
								const file = e.target.files[0];
								createArticleImageURL(file);
							}}
						/>
						<p style={{ fontSize: 12 }}>(deixe vazio para apenas parágrafo)</p>
					</div>

					<div className="articleImage-wrapper">
						<img src={articleImageURL} alt="imagem do artigo" />
					</div>
				</div>
			);

		case 4:
			return (
				<div className="articleDefiner-wrapper">
					<div className="input-wrapper">
						<label htmlFor="titleArticle">Titulo do artigo</label>
						<input
							type="text"
							id="titleArticle"
							onChange={(e) => setArticleTitle(e.target.value)}
							value={titleArticle}
						/>
					</div>
					<div className="input-wrapper">
						<label htmlFor="descriptionArticle">Descrição do artigo</label>
						<textarea
							id="descriptionArticle"
							onChange={(e) => setArticleDesc(e.target.value)}
							value={descArticle}></textarea>
					</div>
					<div className="input-wrapper">
						<label htmlFor="articleVideo">Link do vídeo</label>
						<input
							id=""
							type="text"
							placeholder="ex: https://youtube.com/...."
							value={getEmbedUrl(videoURL)}
							onChange={(e) => setVideoURL(e.target.value)}
						/>
					</div>
					<div className="articleVideo-wrapper">
						<iframe
							src={getEmbedUrl(videoURL)}
							allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share;"
							title="video"
							referrerPolicy="strict-origin-when-cross-origin"
							frameBorder="0"></iframe>
					</div>
				</div>
			);

		default:
			return null;
	}
}
